import React, { useState } from 'react';
import { Modal, Button, Input } from '@/components/shared/ui';
import { VideoLecture } from '../../types/curriculum';

interface AddVideoModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAdd: (video: VideoLecture) => void;
}

export default function AddVideoModal({
    isOpen,
    onClose,
    onAdd
}: AddVideoModalProps): React.ReactElement {
    const [title, setTitle] = useState('');
    const [url, setUrl] = useState('');
    const [authorName, setAuthorName] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = () => {
        if (!title.trim()) {
            setError('강의 제목을 입력해주세요.');
            return;
        }
        if (!url.trim()) {
            setError('동영상 URL을 입력해주세요.');
            return;
        }
        if (!authorName.trim()) {
            setError('강의저자를 입력해주세요.');
            return;
        }

        setError('');

        const newVideo: VideoLecture = {
            id: `video-${Date.now()}`,
            title,
            url: url.trim(),
            duration: '00:00',
            author: {
                name: authorName.trim(),
                type: 'institution'
            },
            description: description.trim() || undefined
        };

        onAdd(newVideo);
        resetForm();
    };

    const resetForm = () => {
        setTitle('');
        setUrl('');
        setAuthorName('');
        setDescription('');
        setError('');
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={resetForm} title="동영상 강의 추가">
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        강의 제목 <span className="text-red-500">*</span>
                    </label>
                    <Input
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="강의 제목을 입력하세요"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        동영상 URL <span className="text-red-500">*</span>
                    </label>
                    <Input
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        placeholder="https://example.com/video"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        강의저자 <span className="text-red-500">*</span>
                    </label>
                    <Input
                        value={authorName}
                        onChange={(e) => setAuthorName(e.target.value)}
                        placeholder="강의저자를 입력하세요"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        설명
                    </label>
                    <textarea
                        className="text-sm w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                        rows={3}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="강의에 대한 설명을 입력하세요"
                    />
                </div>

                {error && (
                    <p className="text-sm text-red-600">{error}</p>
                )}

                <div className="flex justify-end gap-2 mt-6">
                    <Button variant="secondary" onClick={resetForm}>
                        취소
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        추가
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
